import { render, staticRenderFns } from "./FormTransferenciaConta.vue?vue&type=template&id=747fc3cc"
import script from "./FormTransferenciaConta.vue?vue&type=script&lang=js"
export * from "./FormTransferenciaConta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports